/**
 * Fetches the signed-in tenant's runtime config once at boot (P1).
 *
 * Renders nothing. Sits inside <MsalProvider> so it can see the account state:
 * the fetch fires when a real account exists, or immediately under the e2e
 * auth-bypass seam (same condition as App's AuthGate). On any failure the app
 * simply stays on its baked environment descriptor — the pre-P1 behaviour.
 */

import { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';

import ConfigService from '../services/ConfigService';
import { loadRuntimeConfig } from '../../__settings__/runtimeConfig';

const RuntimeConfigLoader = (): null => {
  const { accounts } = useMsal();
  const authed = process.env.REACT_APP_E2E === 'true' || accounts.length > 0;

  useEffect(() => {
    if (authed) {
      loadRuntimeConfig(() => ConfigService.getConfig());
    }
  }, [authed]);

  return null;
};

export default RuntimeConfigLoader;
